var numbersOnDefault = true;

function initNumbers() {
    if(numbersOnDefault) {
        $('.counter__number span').each(function () {
            $(this).prop('Counter',0).animate({
                Counter: $(this).text()
            }, {
                duration: 3000,
                easing: 'linear',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                }
            });
        });
    }
    numbersOnDefault = false;
}

function initGifs() {
    $('.counter__dekor--op-1.preload').each(function(){
        $(this).attr('src',$(this).data('src'));
        $(this).removeClass('preload');
    });
}

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();
	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();
	return elementBottom > viewportTop && elementTop < viewportBottom;
};

(function($) {
    "use strict";
    $(function() {

        if($('.counter__trigger').length > 0) {
        	$(window).scroll(function(){
        		if($('.counter__trigger .counter__number').isInViewport()) {
            		initNumbers();
        		}
        	});
        }

        if($('.counter--animated').length > 0) {
            $(window).scroll(function(){
                if($(window).width() >= 768 ) {
                    if($('.js-gif-trigger').isInViewport()) {
                        initGifs();
                    }
                } else {
                    if($('.js-mobile-gif-trigger').isInViewport()) {
                        initGifs();
                    }
                }
            });
        }

    });
})(jQuery);